// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { openTourModal, closeTourModal } from '../../actions/modals'
import Tour from './components/Tour'
import TourModal from './components/TourModal'

const TourList = styled.div`
  background: #fff;
  padding-bottom: 2rem;
`

const TourDetails = styled.div`
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 2rem;
`

type Props = {
  openTourModal: Function,
  closeTourModal: Function,
  tourModalOpen: boolean,
  tourModalOptions: Object
}

class VirtualTours extends Component {
  props: Props

  handleTourClick = (options) => this.props.openTourModal(options)

  render() {
    return (
      <TourList>
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-xs-12">
              <Tour
                onClick={this.handleTourClick}
                src="https://my.matterport.com/show/?m=gdgEfHvbTbM"
              />
              <TourDetails>
                <div>Custom Build in Mahomet Illinois</div>
                <div>Courtesy of Nelson Construction</div>
              </TourDetails>
            </div>
            <div className="col-lg-4 col-xs-12">
              <Tour
                onClick={this.handleTourClick}
                src="https://my.matterport.com/show/?m=JQ4UipX3dBL"
              />
              <TourDetails>
                <div>Custom Lake Home in Loda Illinois</div>
                <div>Courtesy of a Loda Resident</div>
              </TourDetails>
            </div>
            <div className="col-lg-4 col-xs-12">
              <Tour
                onClick={this.handleTourClick}
                src="https://my.matterport.com/show/?m=psocVnDGARE"
              />
              <TourDetails>
                <div>Custom Build in Buckley Illinois</div>
                <div>Courtesy of Premier Construction</div>
              </TourDetails>
            </div>
          </div>
        </div>
        <TourModal
          isOpen={this.props.tourModalOpen}
          options={this.props.tourModalOptions}
          onRequestClose={this.props.closeTourModal}
        />
      </TourList>
    )
  }
}

export default connect(
  (state) => ({
    tourModalOpen: state.modals.tourModalOpen,
    tourModalOptions: state.modals.tourModalOptions
  }),
  {
    openTourModal,
    closeTourModal
  }
)(VirtualTours)



// WEBPACK FOOTER //
// ./src/components/VirtualTours/index.js